import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "lot-info-card-main",
  class: "lot-info-card box-shadow"
}
const _hoisted_2 = { class: "item-title" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "bid-confirm-place" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "metas" }
const _hoisted_7 = { class: "metas__row catalog" }
const _hoisted_8 = {
  key: 0,
  class: "value"
}
const _hoisted_9 = {
  key: 0,
  class: "metas__row catalog-value"
}
const _hoisted_10 = { class: "value" }
const _hoisted_11 = {
  key: 1,
  class: "metas__row condition"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  class: "lot-info-bid-fixed-block-wrapper",
  ref: "fixedInfoBidWrapper"
}
const _hoisted_14 = {
  class: "lot-info-bid-fixed-block",
  ref: "fixedInfoBidBlock"
}
const _hoisted_15 = { class: "current-bid-block" }
const _hoisted_16 = {
  key: 0,
  class: "bid-status"
}
const _hoisted_17 = { class: "label" }
const _hoisted_18 = {
  key: 1,
  class: "bid-status"
}
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = {
  key: 0,
  class: "lot-card__converted-bid"
}
const _hoisted_22 = { class: "lot-card__fast-bid big" }
const _hoisted_23 = {
  key: 1,
  class: "reopen-block"
}
const _hoisted_24 = { class: "actions" }
const _hoisted_25 = { class: "currency-btn" }
const _hoisted_26 = { class: "bid-confirm-block" }
const _hoisted_27 = { class: "inner" }
const _hoisted_28 = { class: "row-bid-info with-place-bid" }
const _hoisted_29 = { class: "label" }
const _hoisted_30 = { class: "row-bid-info" }
const _hoisted_31 = { class: "label" }
const _hoisted_32 = { class: "value" }
const _hoisted_33 = { class: "label" }
const _hoisted_34 = { class: "value" }
const _hoisted_35 = {
  key: 0,
  class: "row-bid-info last converted-bid"
}
const _hoisted_36 = { class: "label" }
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "bid-btns" }
const _hoisted_39 = ["innerHTML"]

import {computed, markRaw, onMounted, onUnmounted, reactive, ref, watch} from "vue";
  import {useAuctionStore} from "@/stores/AuctionStore";
  import {format_currency} from "@/utils/currencies";
  import {trans} from "@/utils/trans";
  import {formatCatalogValueRange} from "@/utils/lot";
  import {initPopupBidsCountListener, initPopupCurrentBidListener, removeListener} from "@/utils/websockets";
  import FavoriteButton from "@/components/_partials/FavoriteButton.vue";
  import Magnifier from "@/components/_partials/MagnifierOuter.vue";
  import {
    AuthPopup,
    BidsCount,
    BidStatus,
    ConvertedAmount,
    CurrentBid,
    ErrorPopupWrapper,
    LotBidsList,
    LotCurrencyBtn,
    PlaceBidBtn,
    SelectBidBtn,
    SelectBidDropdown
  } from "@/components/_partials/lot-info-popup";

  import {ILotPopupData} from "@/models";
  import {isScreenT} from "@/utils/media-size";
  import {AuctionStatuses, LotSoldStatuses, LotStatuses} from "@/enum";
  import apiClient from "@/services/api";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CardInfoBlock',
  emits: ["closeForm"],
  setup(__props, { emit: __emit }) {

  const emit = __emit;

  const auctionStore = useAuctionStore();
  const selectBidDropdownFirst = ref<HTMLDivElement>(null);
  const selectBidDropdownSecond = ref<HTMLDivElement>(null);
  const authPopupRef = ref<HTMLDivElement>(null);
  const errorPopupRef = ref<HTMLDivElement>(null);

  const popupLot = computed(() => auctionStore.popupLot as ILotPopupData);
  const auctionStatus = computed(() => auctionStore.auction.status);
  const popupLotFiles = computed(() => popupLot.value.values?.files);
  const soldStatus = computed(() => popupLot.value?.sold_status);
  const catalogsWithValue = computed(() => popupLot.value?.catalogs?.filter(c => c.value !== null));

  const popupCurrentBid = computed(() => popupLot.value.current_bid);
  const bidsCount = computed(() => popupLot.value.bids_count);
  const isCurrencyBase = computed(() => auctionStore.isCurrencyBase);

  const reopenLotState = ref<'reopen' | 'confirm'>('reopen');

  const state = reactive({
    lotId: popupLot.value.id,
    buyersPremium: 0,
    totalAmount: 0,

    selectBidBtnLabel: "",
    selectedBid: 0,
    userBid: auctionStore.user?.bids[popupLot.value.id] ?? 0,

    isConfirmationStep: false,
    isPending: false,

    bidsListComponent: markRaw(LotBidsList),
    bidsList: []
  });

  watch(
    () => popupLot.value.status,
    (newValue) => {
      if (newValue === LotStatuses.LIVE) {
        state.isConfirmationStep = false;
      }
    }
  );

  watch(
    () => state.selectedBid,
    (newValue) => {
      if (selectBidDropdownFirst.value) {
        selectBidDropdownFirst.value.selectItem(newValue);
      }
      if (selectBidDropdownSecond.value) {
        selectBidDropdownSecond.value.selectItem(newValue);
      }

      state.buyersPremium = calcBuyersPremium(newValue);

      state.totalAmount = state.selectedBid + state.buyersPremium;
    }
  );

  onMounted(() => {
    initPopupCurrentBidListener(popupLot.value);
    initPopupBidsCountListener(popupLot.value);
  });

  onUnmounted(() => {
    if (auctionStore.popupCurrentBidListener) {
      removeListener(auctionStore.popupCurrentBidListener);
    }
    if (auctionStore.popupBidsCountListener) {
      removeListener(auctionStore.popupBidsCountListener);
    }
  });

  const updateSelectedBid = (value) => {
    state.selectedBid = value;
  };
  const selectBid = () => {
    if (!auctionStore.user?.id) {
      authPopupRef.value?.open();
      return;
    }
    changeConfirmationStep(true);
  };
  const placeBid = () => {
    if (auctionStore.user.id) {
      apiClient
        .post("/api/lots/" + state.lotId + "/place-bid", {
          amount: state.selectedBid
        })
        .then((response) => {
          if (response.data.success) {
            changeConfirmationStep(false);
            state.userBid = response.data.amount;
          }
        })
        .catch((error) => {
          console.log(error);

          const errors = error.response.data.errors;
          if (Object.keys(errors).length) {
            errorPopupRef.value?.openPopup(errors);
            state.isConfirmationStep = false;
          }
        });
    }
  };

  const cancelBid = () => {
    changeConfirmationStep(false);
  };

  const updateIsPending = (value) => {
    state.isPending = value;
  };

  const calcBuyersPremium = (price) => {
    if (popupLot.value.buyers_premium.type === "Percent") {
      let percent = popupLot.value.buyers_premium.value;
      return state.selectedBid * (+percent / 100);
    } else if (popupLot.value.buyers_premium.type === "Range") {
      let rules = popupLot.value.buyers_premium.value;
      for (let i = rules.length - 1; i >= 0; i--) {
        if (price >= rules[i].min_sale_price) {
          return state.selectedBid * (+rules[i].fee_percent / 100);
        }
      }
    }

    return 0;
  };

  const makeProxyBid = () => {
    if (!auctionStore.user?.id) {
      authPopupRef.value?.open();
      return;
    }
    changeConfirmationStep(true);
  };

  const reopenLot = async () => {
    if (reopenLotState.value === 'reopen') {
      reopenLotState.value = 'confirm';
    } else {
      await auctionStore
        .reopenLot(popupLot.value)
        .then((response) => {
          emit("closeForm");
        })
        .catch((error) => {
          console.log(error);
        });

      reopenLotState.value = 'reopen';
    }
  };

  const changeConfirmationStep = (value) => {
    state.isConfirmationStep = value;

    if (isScreenT.value) {
      if (value) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
    }
  };

  const close = () => (auctionStore.popupLot = null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Magnifier, {
        "swiper-main-class": ".main-lot-image .swiper-wrapper",
        "zoom-elements-class": ".magnifier-zoom-image .magnifier-zone",
        type: "gallery",
        "files-prop": popupLotFiles.value
      }, null, 8, ["files-prop"]),
      _createElementVNode("h1", _hoisted_2, [
        _createElementVNode("a", {
          href: popupLot.value.href
        }, _toDisplayString(_unref(trans)("live.catalog.lot_card.lot_number", { number: popupLot.value.lot_number })) + ": " + _toDisplayString(popupLot.value.title), 9, _hoisted_3)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['item-categories', { 'no-margin': !popupLot.value.description || popupLot.value.description?.length === 0 }])
      }, _toDisplayString(popupLot.value.parent_category) + " / " + _toDisplayString(popupLot.value.category), 3),
      _createElementVNode("div", {
        class: _normalizeClass(["bid-confirm-wrapper", { 'is-confirm-step': state.isConfirmationStep }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CustomScrollbar, { class: "custom-scrollbar lot-details-popup-description-scroller" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "description",
                innerHTML: popupLot.value.description
              }, null, 8, _hoisted_5),
              _createElementVNode("div", _hoisted_6, [
                (popupLot.value.catalogs && popupLot.value.catalogs.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createTextVNode(_toDisplayString(_unref(trans)("live.catalog.catalog")) + " ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popupLot.value.catalogs, (catalog, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            class: "value"
                          }, [
                            _createTextVNode(_toDisplayString(catalog.name) + " " + _toDisplayString(catalog.number), 1),
                            (index !== popupLot.value.catalogs.length - 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, ", "))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      (catalogsWithValue.value?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createTextVNode(_toDisplayString(_unref(trans)("live.catalog.catalog_value")) + " ", 1),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(formatCatalogValueRange)(popupLot.value)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                ((popupLot.value.conditions && popupLot.value.conditions.length) || popupLot.value.condition_notes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_unref(trans)("live.catalog.condition")) + " ", 1),
                      (popupLot.value.conditions.length)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "value",
                            innerHTML: popupLot.value.conditions.map((condition) => condition.name).join(', ') + '. '
                          }, null, 8, _hoisted_12))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(popupLot.value.condition_notes), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          (
          [_unref(LotStatuses).LIVE, _unref(LotStatuses).ENDED].includes(popupLot.value.status) &&
          [_unref(AuctionStatuses).LIVE, _unref(AuctionStatuses).ENDED].includes(auctionStatus.value)
        )
            ? (_openBlock(), _createBlock(_unref(BidStatus), {
                key: 0,
                class: "top",
                "lot-data": popupLot.value,
                "user-bid-prop": state.userBid,
                "hidden-pending-prop": true,
                "onUpdate:isPending": updateIsPending
              }, null, 8, ["lot-data", "user-bid-prop"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: _normalizeClass(['current-bid', soldStatus.value?.toLowerCase()])
                }, [
                  (soldStatus.value === _unref(LotSoldStatuses).UNSOLD)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(trans)("lot.card_info_block.bid_labels.unsold")), 1)
                      ]))
                    : (soldStatus.value === _unref(LotSoldStatuses).SOLD)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(trans)("lot.card_info_block.bid_labels.lot_sold")), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(format_currency)(popupLot.value.sale_price)), 1)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createVNode(_unref(CurrentBid), {
                            class: "lot-card__current-bid",
                            "current-bid-prop": popupCurrentBid.value
                          }, null, 8, ["current-bid-prop"]),
                          (!isCurrencyBase.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createTextVNode(_toDisplayString(_unref(trans)("lot.card_info_block.bid_labels.converted")) + " ", 1),
                                _createVNode(_unref(ConvertedAmount), {
                                  "amount-prop": popupLot.value.current_bid
                                }, null, 8, ["amount-prop"])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                ], 2),
                _createVNode(_unref(bidsCount))
              ]),
              ([_unref(AuctionStatuses).ACTIVE, _unref(AuctionStatuses).LIVE].includes(auctionStatus.value))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (popupLot.value.status == _unref(LotStatuses).PREPARED)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["place-bid-block", { 'with-status-bid': state.isPending || state.userBid }])
                        }, [
                          _createVNode(_unref(BidStatus), {
                            "lot-data": popupLot.value,
                            "user-bid-prop": state.userBid,
                            "onUpdate:isPending": updateIsPending
                          }, null, 8, ["lot-data", "user-bid-prop"]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_unref(SelectBidDropdown), {
                              "direction-vertical-prop": "bottom",
                              "lot-data": popupLot.value,
                              "user-bid-prop": state.userBid,
                              "current-bid-prop": popupCurrentBid.value,
                              "bids-count-prop": bidsCount.value,
                              "onUpdate:selectedBid": updateSelectedBid,
                              ref_key: "selectBidDropdownFirst",
                              ref: selectBidDropdownFirst
                            }, null, 8, ["lot-data", "user-bid-prop", "current-bid-prop", "bids-count-prop"]),
                            _createVNode(_unref(SelectBidBtn), {
                              "user-bid-prop": state.userBid,
                              "place-bid-prop": "lot-page",
                              onSelectBid: selectBid
                            }, null, 8, ["user-bid-prop"])
                          ])
                        ], 2))
                      : (
                _unref(auctionStore).user?.is_admin &&
                popupLot.value.status === _unref(LotStatuses).ENDED
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("a", {
                              href: "#",
                              class: "btn btn-blue w-100",
                              onClick: _withModifiers(reopenLot, ["prevent"])
                            }, _toDisplayString(reopenLotState.value === 'reopen'
                      ? _unref(trans)('live.action_buttons.reopen_lot_label')
                      : _unref(trans)('live.action_buttons.confirm_reopen_lot_label')), 1)
                          ]))
                        : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 512)
          ], 512),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(FavoriteButton, {
              "lot-id-prop": popupLot.value.id,
              "subscribers-count-prop": popupLot.value.subscribers_count,
              "show-count": ""
            }, null, 8, ["lot-id-prop", "subscribers-count-prop"]),
            (auctionStatus.value !== _unref(AuctionStatuses).ENDED && soldStatus.value !== _unref(LotSoldStatuses).UNSOLD)
              ? (_openBlock(), _createBlock(_unref(LotCurrencyBtn), { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_25, [
                      _cache[0] || (_cache[0] = _createElementVNode("svg", { class: "icon-coin" }, [
                        _createElementVNode("use", { href: "/sprite.svg#coin" })
                      ], -1)),
                      _createTextVNode(" " + _toDisplayString(_unref(auctionStore).currency), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_unref(CurrentBid), {
              class: "row-bid-info",
              "current-bid-prop": popupCurrentBid.value
            }, null, 8, ["current-bid-prop"]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(trans)("lot.confirmation.maximum_bid")), 1),
              _createVNode(_unref(SelectBidDropdown), {
                "dropdown-custom-class": "invert",
                "lot-data": popupLot.value,
                "user-bid-prop": state.userBid,
                "current-bid-prop": popupCurrentBid.value,
                "bids-count-prop": bidsCount.value,
                "onUpdate:selectedBid": updateSelectedBid,
                ref_key: "selectBidDropdownSecond",
                ref: selectBidDropdownSecond
              }, null, 8, ["lot-data", "user-bid-prop", "current-bid-prop", "bids-count-prop"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(trans)("lot.confirmation.buyers_premium")), 1),
              _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(format_currency)(state.buyersPremium)), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row-bid-info", { last: isCurrencyBase.value }])
            }, [
              _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(trans)("lot.confirmation.total_amount")), 1),
              _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(format_currency)(state.totalAmount)), 1)
            ], 2),
            (!isCurrencyBase.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(trans)("lot.confirmation.converted_total")), 1),
                  _createVNode(_unref(ConvertedAmount), {
                    "amount-prop": state.totalAmount
                  }, null, 8, ["amount-prop"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "description-bid",
              innerHTML: _unref(trans)('lot.confirmation.description').replace(':link', '/conditions-of-sale')
            }, null, 8, _hoisted_37)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              class: "btn btn-blue-outline",
              onClick: cancelBid,
              innerHTML: _unref(trans)('lot.confirmation.buttons.cancel')
            }, null, 8, _hoisted_39),
            _createVNode(_unref(PlaceBidBtn), { onPlaceBid: placeBid })
          ])
        ])
      ], 2)
    ]),
    _createVNode(_unref(AuthPopup), {
      message: _unref(trans)('lot.card_info_block.place_bid_btn.notify_for_login'),
      ref_key: "authPopupRef",
      ref: authPopupRef
    }, null, 8, ["message"]),
    _createVNode(_unref(ErrorPopupWrapper), {
      ref_key: "errorPopupRef",
      ref: errorPopupRef
    }, null, 512)
  ], 64))
}
}

})